import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'donottravel',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './indonesiasmtagungvolcano.component.html',
  styleUrl: './indonesiasmtagungvolcano.component.scss',
})
export class IndonesiasmtagungvolcanoComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = '';

  ngOnInit() {
    this.titleService.setTitle(
      'Mt Agung Volcano Travel Insurance Updates | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'World2Cover travel insurance update: Mt Agung volcano eruption in Bali causes ash clouds and possible flight disruptions. Check coverage and travel advice.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Mt Agung Volcano Travel Insurance Updates | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'World2Cover travel insurance update: Mt Agung volcano eruption in Bali causes ash clouds and possible flight disruptions. Check coverage and travel advice.',
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/faqs.jpg';
    this.pageHead = `Indonesia’s Mt Agung Volcano Travel Insurance Updates`;
  }
}
